export type TitleProps = { text: string };
export const TitleToken = 'text.title';
